module.exports = __webpack_public_path__ + "static/img/noData.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/noData.png
// module id = cL9z
// module chunks = 2